import { render, staticRenderFns } from "./saveUpdate.vue?vue&type=template&id=084e369f&scoped=true"
import script from "./saveUpdate.vue?vue&type=script&lang=js"
export * from "./saveUpdate.vue?vue&type=script&lang=js"
import style0 from "./saveUpdate.vue?vue&type=style&index=0&id=084e369f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e369f",
  null
  
)

export default component.exports